// components/common/OptimizedImage.tsx
// Uses next/image for automatic WebP/AVIF conversion, LCP optimization, and proper lazy loading
"use client";
import React, { useState } from "react";
import Image from "next/image";

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  sizes?: string;
  style?: React.CSSProperties;
  fill?: boolean;
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width = 800,
  height = 600,
  className = "",
  priority = false,
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw",
  style,
  fill = false,
}) => {
  const [error, setError] = useState(false);

  // Fallback for empty/missing/broken src
  const imgSrc =
    !src || src.trim() === "" || src === "#" || error
      ? "/images/placeholder.jpg"
      : src;

  if (fill) {
    return (
      <Image
        src={imgSrc}
        alt={alt || "Image"}
        fill
        priority={priority}
        loading={priority ? "eager" : "lazy"}
        sizes={sizes}
        className={className}
        style={style}
        unoptimized={false}
        onError={() => setError(true)}
        crossOrigin="anonymous"
      />
    );
  }

  return (
    <Image
      src={imgSrc}
      alt={alt || "Image"}
      width={width}
      height={height}
      priority={priority}
      loading={priority ? "eager" : "lazy"}
      sizes={sizes}
      className={className}
      style={style}
      unoptimized={false}
      onError={() => setError(true)}
      crossOrigin="anonymous"
    />
  );
};
